import ProxyButton from '../../../components/common/ProxyButton';
import { I18N_MAPPING, TOTP_PROVIDER_AMPLITUDE_EVENT } from '../../../constants';
import AmplitudeUtils from '../../../utils/amplitude-utils';
import { getLocalizedString } from '../../../utils/i18n-utils';
import EnrollPollBaseCustomizer from './base';

export default class EnrollPollQrCodeCustomizer extends EnrollPollBaseCustomizer {
  async shouldCustomize() {
    return (await super.shouldCustomize()) && this.selectedChannel === 'qrcode';
  }

  async customize() {
    AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT['OKTA']}TotpBarcodeScan::Landing`);
    await super.customize();
    this.forgifyQrCodeInstructions();
    this.forgifyCantScanLink();
    this.replaceComponents();
  }

  private forgifyQrCodeInstructions() {
    const qrCodeInstructions: JQuery<HTMLElement> = jQueryCourage('.qrcode-info');
    if (qrCodeInstructions.length) {
      this.renderForgeAndHideOktaComponent({
        id: 'qr-code-instructions',
        oktaComponent: qrCodeInstructions,
        forgeComponent: <p>{getLocalizedString('okta.verify.setup.instructions')}</p>,
      });
    }
  }

  private forgifyCantScanLink() {
    const cantScanLink: JQuery<HTMLElement> = jQueryCourage('.switch-channel-link');
    if (cantScanLink.length) {
      const forgeComponent = <ProxyButton oktaButton={cantScanLink} fullWidth variant="tertiary" textToOverride={I18N_MAPPING['en']['oie.enroll.okta_verify.qrcode.cannotScan']} />;
      this.renderForgeAndHideOktaComponent({
        id: 'cant-scan-link',
        oktaComponent: cantScanLink,
        forgeComponent: forgeComponent,
      });
    }
  }
}
